import BaseService from '_services/rest/base';

class SupervisorService extends BaseService {
  constructor() {
    super();
  }

  getUrl() {
    return `${super.getUrl()}/api/supervisor`;
  }

  getListAll() {
    return this.request(`${this.getUrl()}/all`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getList(params) {
    const filters = { search: params.search };

    return this.request(
      `${this.getUrl()}/all/${params.skip}/${params.take}`,
      filters
    )
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getSupervisorById(id) {
    return this.request(`${this.getUrl()}/${id}`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  save(supervisor) {
    return this.request(`${this.getUrl()}/${supervisor.id}`, supervisor, 'PUT')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  delete(id) {
    return this.request(`${this.getUrl()}/${id}`, null, 'DELETE').catch(err => {
      throw err;
    });
  }

  getSupervisorDistributors(params) {
    const filters = { search: params.search, uf: params.state, group: params.group };
    return this.request(
      `${this.getUrl()}/resellers/${params.id}/${params.skip}/${params.take}`,
      filters
    )
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  syncResellers({ id, resellers }) {
    return this.request(
      `${this.getUrl()}/resellers/${id}`,
      { resellers },
      'PUT'
    ).catch(err => {
      throw err;
    });
  }
}

export default new SupervisorService();
